export default __webpack_public_path__ + "static/media/check.ba202724.svg";